/*!
=========================================================
* お知らせ管理　詳細
=========================================================
*/
import React from "react";
import { Link } from 'react-router-dom';

import {
  Button,
  Card, CardHeader, CardTitle,
  Table, Row, Col,
} from "reactstrap";

import Request from '../../common/Request';
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import InputRadio from '../FormParts/InputRadio';
import WithRole from '../FormParts/ButtonWithRole';
import Format from '../../common/Format'
import Images from '../ViewParts/Images';

const domain = "";

/*
*　クラス名：
*     Detail   ：詳細表示用クラス
*/
class Detail extends React.Component {
  /*
  *　関数・変数名：
  *     constructor     　：コンストラクタ関数
  *                         ロード時に1度だけ呼び出される
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */  
  constructor(props) {

    /*
    *　関数・変数名：
    *     super     　      ：親のコンストラクターを呼び、thisを使えるようにする
    *  パラメータ 説明：
    *     props            ：GETやPOSTなどのパラメータ入力値
    */
    super(props);

    /*
    *　関数・変数名：
    *     this.state    ：stateの初期設定
    *  KEY 説明：（※）は必須
    * 
    *     ▼画面毎設定　
    *     supplier_id       ：詳細画面用のパラメータ
    *     
    *     ▼共通設定
    *     data              ：更新画面用の元データ格納変数
    *     view              ：新規・更新の判定用変数
    *                         true : 更新   false ： 新規登録      
    */   
    this.state = {
      supplier_id: this.props.match.params.supplier_id,
      data: {
        values:{
          image_url:[]
        }
      },
      value: "",
      copied: false,
      title:"お知らせ管理詳細",
      targetCustomers:[]
    };

    /*
    *　動的なデータの変更が詳細画面ではないため、
    *　constructorにて、詳細データを取得し、初期値に設定
    */     
    let params = {};
    var url = domain + '/api/information/' + this.props.match.params.information_id;
    /* ここから検索 */
    Request.get(url, params, res => {
      this.setState({ data: {
        values:{
          ...res.Data,
          image_url: res.data.image_url?res.data.image_url.split(','):[]
        }
      } });
      var url = domain + '/api/landmark/lastupdate/' + res.Data.update_user_id;
      var params = {};
      Request.get(url, params, res => {
        let tmp = this.state.data.values;
        tmp.lastupdate_user = res.Data;
        this.setState({data:{values:tmp}});
      });
    });
    Request.get(`/api/information/target`, {information_id : this.props.match.params.information_id}, res => {
      this.setState({
        targetCustomers:res.Data
      });
    });
  }

  /*
  *　関数・変数名：
  *     render ：react.Componentで用意されているrender関数
  *              この関数内のタグが表示される
  *     
  */
  render() {
    const {values} = this.state.data
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.data.values)
    console.log(values);
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="6">
                      <CardTitle tag="h3" className="float-left">{this.state.title}</CardTitle>
                    </Col>
                    <Col md="6">
                      <ButtonWithRole button_id="" className="float-right" onClick={() => { this.props.history.push('/information/update/' + values.information_id) }}>編集</ButtonWithRole>
                    </Col>
                  </Row>
                </CardHeader>
                <Col md="11" className="detail">
                  <SystemInfo
                    id_title='お知らせID'
                    id_value={values.information_id}
                    update_timestamp={values.update_date}
                    update_user={values.lastupdate_user && values.lastupdate_user.name}
                    update_user_picture={values.lastupdate_user && values.lastupdate_user.picture} />

                  <CardTitle tag="h4" className="float-left">お知らせ管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        <CustomTd 
                          label="登録単位" 
                          name="INFORMATION__data_type" 
                          copy={false} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                            label="非ログインユーザー向け表示フラグ" 
                            name="INFORMATION__not_login" 
                            copy={false} 
                            data={values}
                          />              
                      </tr>
                      <tr>
                        <CustomTd 
                          label="ターゲット" 
                          name="INFORMATION__target_customers" 
                          copy={false} 
                          rootData={this.state.data}
                          value={
                            <div  className="imageComponent" style={{ width: "100%", height: "200px", overflowX: "hidden", overflowY: "scroll" }}>
                              {this.state.targetCustomers.map((customer)=>{
                                return (
                                  <Row>
                                    <Col>
                                      {`${customer.customer_name ? customer.customer_name : ''}`} 
                                    </Col>
                                    <Col>
                                      {`${customer.customer_branch_name ? customer.customer_branch_name : ''}`} 
                                    </Col>
                                    <Col>
                                      {`${customer.customer_user_name ? customer.customer_user_name : ''}`} 
                                    </Col>
                                  </Row>
                                  )
                              })}
                            </div>
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="掲載開始日時" 
                          name="INFORMATION__start_date" 
                          copy={false} 
                          value={Format.format_datetime(values.start_date)}
                          
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="掲載終了日時" 
                          name="INFORMATION__end_date" 
                          copy={false} 
                          value={Format.format_datetime(values.end_date)}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="件名" 
                          name="INFORMATION__subject" 
                          copy={false} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="内容" 
                          name="INFORMATION__body" 
                          copy={false} 
                          value={
                            <div style={{whiteSpace: "pre-line"}}>
                              {values.body}
                            </div>
                          }
                        />
                      </tr>
                      <tr>
                        <td className="subTitle">画像アップロード</td>
                        <td colSpan="3">
                            <Images image_items={this.state.data.values && (this.state.data.values.image_url || [])} />
                        </td>
                      </tr>
                      <tr>
                        <CustomTd 
                          label="外部URL" 
                          name="INFORMATION__ad_url" 
                          copy={false} 
                          value={
                            this.state.data.values.ad_url && <Link onClick={()=>{window.open(this.state.data.values.ad_url)}}>
                              {`${this.state.data.values.ad_url}`}
                            </Link>
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="表示位置ヘッダー" 
                          name="INFORMATION__display_header" 
                          copy={false} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="表示位置広告エリア" 
                          name="INFORMATION__display_advertisement" 
                          copy={false} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="状態" 
                          name="INFORMATION__status" 
                          copy={false} 
                          data={values}
                        />
                      </tr>
                    </tbody>
                  </Table>

                  <Button onClick={() => { this.props.history.push('/information') }} className="float-left">一覧に戻る</Button>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default Detail;
